module.exports = __webpack_public_path__ + "images/dingtalk/init-member-193040f5c7edfbe373f6e09668117694.png";